import React, { Component } from 'react'
import { Pdf, Upload } from './'
import { ButtonPDFCard, ButtonCard, PanelPDFStyle } from './../styles'

export default class PDFButton extends Component {
  state = {
    active: false
  }

  static defaultProps = {
    big: false,
  }

  handlerClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ active: !this.state.active})
  }

  closePanel = (e) => {
    // e.preventDefault()
    e.stopPropagation()
    this.setState({ active: false})
  }

  render() {
    const {big, pdfs} = this.props
    return (
      <div className={ ButtonPDFCard }>
        {
          pdfs && (
            <div>
              <div className={`panel-pdf ${PanelPDFStyle(this.state.active)}`}>
                {
                  pdfs.map((pdf, index) => (
                    <a href={pdf.path} onClick={this.closePanel} download className='pdf-line' key={index}>
                      <span>{pdf.label}</span>
                      <Upload width={24} height={24} />
                    </a>
                  ))
                }
              </div>
              <button className={`btn btn-pdf ${ButtonCard(big)}`} onClick={this.handlerClick}>
                <Pdf width={24} height={24} />
              </button>
            </div>
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PDFButton.js